import { z } from "zod";

export const ImageSchema = z.object({
  name: z.string(),
  filename: z.string(),
});
